import { NgModule } from '@angular/core';
import { SharedV2Module } from '@modules/shared-v2/shared-v2.module';

@NgModule({
    imports: [SharedV2Module],
    providers: [],
    declarations: [],
})
export class MentionsModule {}
